// UserContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { loginUser } from '../../services/api';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userType, setUserType] = useState(null);

    useEffect(() => {
        // Check localStorage for userType on initial load
        const storedUserType = localStorage.getItem('userType');
        if (storedUserType) {
            setUserType(storedUserType);
        }
    }, []);
   
    const login = async (username,password) => {
        const result = await loginUser(username,password);
     
        if (result.status === 200) {
            const { token, userType, userId } = result.data;
            setUserType(userType);
            localStorage.setItem('token', token);
            localStorage.setItem('userType', userType);
            localStorage.setItem('userId', userId);
        } 
        return result;
    };
    return (
        <UserContext.Provider value={{ userType ,login}}>
            {children}
        </UserContext.Provider>
    );
};
export const useUserContext = () => useContext(UserContext);
